import type { FieldArrayMethodProps, FieldArrayWithId } from 'react-hook-form';
import { UltraSelect } from 'components/UltraSelect';
import { supplierSource } from 'data/entity-sources/sources';
import React from 'react';
import styled from 'styled-components';
import { SupplierType } from 'pages/Products/constants/defaultProduct';

type SupplierFields = FieldArrayWithId<
    {
        suppliers: SupplierType[];
    },
    'suppliers',
    'id'
>[];

export const SupplierSelector = ({
    prepend,
    supplierFields,
}: {
    prepend: (value: SupplierType | SupplierType[], options?: FieldArrayMethodProps | undefined) => void;
    supplierFields: SupplierFields;
}) => {
    const onSelect = (value: string | null) => {
        if (value && !supplierFields.some(({ _id }) => _id === value)) {
            prepend({ _id: value, code: '', prices: [] });
        }
    };

    return (
        <SelectorContainer>
            <UltraSelect
                source={supplierSource}
                label="Ajouter un fournisseur "
                placeholder="Recherche par nom ou par _id"
                value={null}
                onChange={onSelect}
                dataTest="product-supplier"
            />
        </SelectorContainer>
    );
};

const SelectorContainer = styled.div`
    width: 100%;
    font-size: 15px;
`;
